var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { invariant } from "../utils.js";
export function getOwedBalance(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "balance"), {
            method: "GET",
        });
        return (yield res.json());
    });
}
export function registerPayment(ctx, companyId, input) {
    return __awaiter(this, void 0, void 0, function* () {
        invariant(typeof input.idempotentKey === "string", "idempotent key required");
        const headers = new Headers();
        headers.set("Idempotent-Key", input.idempotentKey);
        headers.set("Content-Type", "application/json");
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "/payments"), {
            method: "POST",
            headers,
            body: JSON.stringify(input.payments),
        });
        return (yield res.json());
    });
}
export function getBillingTerm(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId), {
            method: "GET",
        });
        return (yield res.json());
    });
}
export function getPayments(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "/payments/query"), {
            method: "POST",
        });
        return (yield res.json());
    });
}
export function getInvoices(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "/bills"), {
            method: "GET",
        });
        return (yield res.json());
    });
}
export function getInvoiceItems(ctx, companyId, invoiceId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "/bills", invoiceId), {
            method: "GET",
        });
        return (yield res.json());
    });
}
export function getInvoiceDocument(ctx, companyId, invoiceId) {
    return __awaiter(this, void 0, void 0, function* () {
        const headers = new Headers({ Accept: "application/pdf" });
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "/bills", invoiceId, "/document"), {
            method: "GET",
            headers,
        });
        if (!res.ok) {
            throw new Error(`Failed to fetch invoice document: ${res.status}`);
        }
        return res.blob();
    });
}
export function getUnifiedBilling(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "/outstanding"), {
            method: "GET",
        });
        return (yield res.json());
    });
}
export function getUnifiedInvoiceDocument(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "/outstanding/document"), {
            method: "GET",
            headers: { Accept: "application/pdf" },
        });
        if (!res.ok) {
            throw new Error(`Failed to fetch invoice document: ${res.status}`);
        }
        return res.blob();
    });
}
const Billing = {
    getOwedBalance,
    registerPaymentToActiveBill: registerPayment,
    getBillingTerm,
    getPayments,
    getInvoices,
    getInvoiceItems,
    getInvoiceDocument,
    getUnifiedBilling,
    getUnifiedInvoiceDocument,
};
export default Billing;
